module.exports = __webpack_public_path__ + "img/1009d_1.dd672512.jpg";